import { toEpochMsOr as e } from "@maat/datetime";
//#region src/rankActions.ts
var t = (t, n) => [...t].sort((t, r) => {
	let i = n(t), a = n(r);
	if (i.order !== a.order) return i.order - a.order;
	let o = e(i.expiresAt, Infinity), s = e(a.expiresAt, Infinity);
	if (o !== s) return o - s;
	let c = i.weight ?? 0, l = a.weight ?? 0;
	return c === l ? e(i.createdAt, 0) - e(a.createdAt, 0) : l - c;
}), n = (e, t, n) => {
	let r = [], i = /* @__PURE__ */ new Set();
	for (let a of e) {
		if (r.length >= t) break;
		let e = n(a);
		i.has(e) || (i.add(e), r.push(a));
	}
	let a = new Set(r), o = /* @__PURE__ */ new Map();
	for (let t of e) {
		if (a.has(t)) continue;
		let e = n(t), r = o.get(e);
		r ? r.count += 1 : o.set(e, {
			group: e,
			count: 1,
			lead: t
		});
	}
	return {
		cards: r,
		overflow: [...o.values()]
	};
};
//#endregion
export { n as selectActionCardsBy, t as sortActionsBy };
